/**
 * @author caijianjia
 * @date 2020/3/20 10:29 上午
 */


const TOKEN_KEY = "im-edit-token";
const getToken = () => localStorage.getItem(TOKEN_KEY);
const setToken = token => localStorage.setItem(TOKEN_KEY, token);
const removeToken = () => localStorage.removeItem(TOKEN_KEY);

const LessonConfig = "lesson-config";
const getConfig = () => localStorage.getItem(LessonConfig);
const setConfig = token => localStorage.setItem(LessonConfig, token);
const removeConfig = () => localStorage.removeItem(LessonConfig);

// 保存被勾选的课件id, 【打包时不再有弹窗】
const warnConfig = "warn-config";
const getWarn = () => localStorage.getItem(warnConfig);
const setWarn = token => localStorage.setItem(warnConfig, token);
const removeWarn = () => localStorage.removeItem(warnConfig);

const TOKEN_COURSE_KEY = "course_auth_token";
const getCourseToken = () => localStorage.getItem(TOKEN_COURSE_KEY);
const setCourseToken = token => localStorage.setItem(TOKEN_COURSE_KEY, token);
const removeCourseToken = () => localStorage.removeItem(TOKEN_COURSE_KEY);

const CUR_TIME_KEY = "cur_time";
const getCurTime = () => localStorage.getItem(CUR_TIME_KEY);
const setCurTime = token => localStorage.setItem(CUR_TIME_KEY, token);
const removeCurTime = () => localStorage.removeItem(CUR_TIME_KEY);

const SchoolId = "school_id";
const getSchoolId = () => localStorage.getItem(SchoolId);
const setSchoolId = token => localStorage.setItem(SchoolId, token);
const removeSchoolId = () => localStorage.removeItem(SchoolId);

const GuideStep = "guide_step";
const getGuideStep = () => localStorage.getItem(GuideStep);
const setGuideStep = token => localStorage.setItem(GuideStep, token);
const removeGuideStep = () => localStorage.removeItem(GuideStep);

export default {
    getToken,
    setToken,
    removeToken,

    getConfig,
    setConfig,
    removeConfig,

    getWarn,
    setWarn,
    removeWarn,

    getCourseToken,
    setCourseToken,
    removeCourseToken,

    getCurTime,
    setCurTime,
    removeCurTime,

    getSchoolId,
    setSchoolId,
    removeSchoolId,

    getGuideStep,
    setGuideStep,
    removeGuideStep
};
